(function () {
  const appCompatibilityMode = Boolean(window.wmAppCompatibilityMode);
  const wishlistKey = 'wm_wishlist_v1';
  const collectionReturnKey = 'wm_last_collection_url_v1';

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function readWishlist() {
    try {
      return JSON.parse(storageGet(wishlistKey)) || [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    storageSet(wishlistKey, JSON.stringify(items));
  }

  function syncWishlistButtons() {
    const wishlist = readWishlist();
    document.querySelectorAll('[data-wm-wishlist-button]').forEach((button) => {
      const handle = button.dataset.productHandle;
      const active = wishlist.includes(handle);
      const label = active ? 'Saved' : 'Save';
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${label} ${button.dataset.productTitle || 'product'}`);
      const text = button.querySelector('[data-wm-wishlist-text]');
      if (text) text.textContent = label;
    });
  }

  function initWishlist() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wm-wishlist-button]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const wishlist = readWishlist();
      const index = wishlist.indexOf(handle);
      if (index >= 0) wishlist.splice(index, 1);
      else wishlist.push(handle);
      writeWishlist(wishlist);
      syncWishlistButtons();
    });

    syncWishlistButtons();
    document.addEventListener('shopify:section:load', syncWishlistButtons);
  }

  function initProductShare() {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-wm-share-button]');
      if (!button) return;

      const shareUrl = button.dataset.shareUrl || window.location.href;
      const shareTitle = button.dataset.shareTitle || document.title;

      if (navigator.share) {
        try {
          await navigator.share({ title: shareTitle, url: shareUrl });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }

      try {
        await navigator.clipboard.writeText(shareUrl);
        const text = button.querySelector('[data-wm-share-text]');
        const originalText = text ? text.textContent : '';
        button.classList.add('is-copied');
        if (text) text.textContent = 'Copied';
        window.setTimeout(() => {
          button.classList.remove('is-copied');
          if (text) text.textContent = originalText || 'Share';
        }, 1800);
      } catch (error) {
        window.prompt('Copy this product link', shareUrl);
      }
    });
  }

  function initDiscountCopy() {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-wm-copy-code]');
      if (!button) return;

      const code = button.dataset.wmCopyCode || '';
      if (!code) return;

      const label = button.querySelector('[data-wm-copy-label]');
      const originalLabel = label ? label.textContent : '';

      try {
        await navigator.clipboard.writeText(code);
        button.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        window.setTimeout(() => {
          button.classList.remove('is-copied');
          if (label) label.textContent = originalLabel || 'Copy';
        }, 1800);
      } catch (error) {
        window.prompt('Copy this discount code', code);
      }
    });
  }

  function moneyFromCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return `Rs. ${(Number(cents || 0) / 100).toLocaleString('en-IN', {
      maximumFractionDigits: 0,
    })}`;
  }

  function optionValueFromVariant(variant, index) {
    return variant[`option${index + 1}`];
  }

  function productOptions(product) {
    return (product.options || []).map((option) => ({
      name: typeof option === 'string' ? option : option.name,
    }));
  }

  function variantMatchesSelection(variant, selectedOptions) {
    return selectedOptions.every((value, index) => optionValueFromVariant(variant, index) === value);
  }

  function findBestVariant(product, selectedOptions) {
    return (
      product.variants.find((variant) => variant.available && variantMatchesSelection(variant, selectedOptions)) ||
      product.variants.find((variant) => variantMatchesSelection(variant, selectedOptions)) ||
      product.variants.find((variant) => variant.available) ||
      product.variants[0]
    );
  }

  function optionValues(product, optionIndex) {
    return product.variants.reduce((values, variant) => {
      const value = optionValueFromVariant(variant, optionIndex);
      if (value && !values.includes(value)) values.push(value);
      return values;
    }, []);
  }

  function canSelectOption(product, selectedOptions, optionIndex, value) {
    const testSelection = selectedOptions.slice();
    testSelection[optionIndex] = value;
    return product.variants.some((variant) => variant.available && variantMatchesSelection(variant, testSelection));
  }

  function escapeHTML(value) {
    const element = document.createElement('span');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function escapeAttribute(value) {
    return escapeHTML(value).replace(/"/g, '&quot;');
  }

  function swatchColor(value) {
    const normalized = String(value || '').trim().toLowerCase();
    const colors = {
      black: '#111111',
      white: '#f5f5f0',
      'off white': '#f7f3ea',
      beige: '#d8c3a5',
      cream: '#f2eadf',
      ivory: '#f6f1e7',
      grey: '#8d8f95',
      gray: '#8d8f95',
      blue: '#456fb3',
      'baby blue': '#c7e2f4',
      navy: '#24324a',
      green: '#5f7d5b',
      jade: '#b8d5be',
      maroon: '#5f2025',
      red: '#b5483f',
      pink: '#d89aa6',
      'light baby pink': '#f3d1dd',
      lavender: '#d8d0f0',
      brown: '#7b5a44',
      yellow: '#d8b84c',
    };

    return colors[normalized] || normalized;
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (typeof url !== 'string') return '';
    if (url.startsWith('//')) return `${window.location.protocol}${url}`;
    return url;
  }

  function imageSourceFrom(image) {
    if (!image) return '';
    if (typeof image === 'string') return normalizeImageUrl(image);

    return normalizeImageUrl(
      image.src ||
        image.url ||
        image.featured_image ||
        image.preview_image?.src ||
        image.preview_image?.url ||
        image.preview_image
    );
  }

  function cardImageSource(sourceButton) {
    const cardImage = sourceButton?.closest('.product-card-wrapper')?.querySelector('.card__media img');
    return normalizeImageUrl(cardImage?.currentSrc || cardImage?.src || '');
  }

  function productImageSource(product, variant, sourceButton) {
    return (
      imageSourceFrom(variant?.featured_image) ||
      imageSourceFrom(product.featured_image) ||
      imageSourceFrom(product.images?.[0]) ||
      imageSourceFrom(product.media?.[0]?.preview_image) ||
      imageSourceFrom(product.media?.[0]) ||
      cardImageSource(sourceButton)
    );
  }

  function updateCartBubble(count) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    let bubble = cartLink.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartLink.appendChild(bubble);
    }

    bubble.innerHTML = `
      <span aria-hidden="true">${count}</span>
      <span class="visually-hidden">${count} items</span>
    `;
  }

  function ensureQuickAddModal() {
    let modal = document.querySelector('[data-wm-quick-add-modal]');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'wm-quick-add-modal';
    modal.setAttribute('data-wm-quick-add-modal', '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="wm-quick-add-modal__backdrop" data-wm-quick-add-close></div>
      <div class="wm-quick-add-modal__panel" role="document">
        <button class="wm-quick-add-modal__close" type="button" data-wm-quick-add-close aria-label="Close">×</button>
        <div class="wm-quick-add-modal__body" data-wm-quick-add-body></div>
      </div>
    `;
    document.body.appendChild(modal);

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-wm-quick-add-close]')) closeQuickAddModal();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeQuickAddModal();
    });

    return modal;
  }

  function closeQuickAddModal() {
    const modal = document.querySelector('[data-wm-quick-add-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wm-quick-add-open');
  }

  function renderQuickAddModal(product, selectedOptions, sourceButton) {
    const modal = ensureQuickAddModal();
    const body = modal.querySelector('[data-wm-quick-add-body]');
    const variant = findBestVariant(product, selectedOptions);
    const featuredImage = productImageSource(product, variant, sourceButton);
    const price = variant?.price ?? product.price;

    body.innerHTML = `
      <div class="wm-quick-add-modal__media">
        ${
          featuredImage
            ? `<img src="${escapeAttribute(featuredImage)}" alt="${escapeAttribute(product.title)}" loading="lazy">`
            : ''
        }
      </div>
      <div class="wm-quick-add-modal__details">
        <p class="wm-quick-add-modal__eyebrow">Quick add</p>
        <h2 class="wm-quick-add-modal__title">${escapeHTML(product.title)}</h2>
        <p class="wm-quick-add-modal__price">${moneyFromCents(price)}</p>
        <form class="wm-quick-add-modal__form" data-wm-quick-add-form>
          ${productOptions(product)
            .map((option, optionIndex) => {
              const isColor = /colou?r/i.test(option.name);
              return `
                <fieldset class="wm-quick-add-modal__option">
                  <legend>${escapeHTML(option.name)}</legend>
                  <div class="wm-quick-add-modal__choices">
                    ${optionValues(product, optionIndex)
                      .map((value) => {
                        const selected = selectedOptions[optionIndex] === value;
                        const available = canSelectOption(product, selectedOptions, optionIndex, value);
                        return `
                          <button
                            class="wm-quick-add-modal__choice${selected ? ' is-selected' : ''}${isColor ? ' is-color' : ''}"
                            type="button"
                            data-wm-option-index="${optionIndex}"
                            data-wm-option-value="${escapeAttribute(value)}"
                            ${available ? '' : 'disabled'}
                          >
                            ${
                              isColor
                                ? `<span class="wm-quick-add-modal__swatch" style="--wm-swatch-color: ${escapeHTML(
                                    swatchColor(value)
                                  )};"></span>`
                                : ''
                            }
                            <span>${escapeHTML(value)}</span>
                          </button>
                        `;
                      })
                      .join('')}
                  </div>
                </fieldset>
              `;
            })
            .join('')}
          <input type="hidden" name="id" value="${variant?.id || ''}">
          <button class="wm-quick-add-modal__submit" type="submit" ${variant?.available ? '' : 'disabled'}>
            ${variant?.available ? 'Add to cart' : 'Sold out'}
          </button>
          <p class="wm-quick-add-modal__message" data-wm-quick-add-message aria-live="polite"></p>
        </form>
      </div>
    `;

    body.querySelectorAll('[data-wm-option-index]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedOptions[Number(button.dataset.wmOptionIndex)] = button.dataset.wmOptionValue;
        renderQuickAddModal(product, selectedOptions, sourceButton);
      });
    });

    body.querySelector('[data-wm-quick-add-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      const submitButton = form.querySelector('.wm-quick-add-modal__submit');
      const message = form.querySelector('[data-wm-quick-add-message]');
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId || !submitButton) return;

      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
      if (message) message.textContent = '';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        }).then((response) => {
          if (!response.ok) throw new Error('Unable to add item');
          return response.json();
        });

        const cart = await fetch('/cart.js').then((response) => response.json());
        updateCartBubble(cart.item_count);
        submitButton.textContent = 'Added';
        if (sourceButton) sourceButton.textContent = 'Added';
        if (message) message.textContent = 'Added to cart.';
        window.setTimeout(() => {
          if (sourceButton && sourceButton.dataset.wmQuickAddOriginalHtml) {
            sourceButton.innerHTML = sourceButton.dataset.wmQuickAddOriginalHtml;
          }
          closeQuickAddModal();
        }, 1100);
      } catch (error) {
        submitButton.disabled = false;
        submitButton.textContent = 'Add to cart';
        if (message) message.textContent = 'Could not add this variant. Please try again.';
      }
    });

    modal.setAttribute('aria-label', `Quick add ${product.title}`);
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('wm-quick-add-open');
    modal.querySelector('.wm-quick-add-modal__close')?.focus();
  }

  async function openQuickAdd(sourceButton) {
    const productUrl = sourceButton.dataset.productUrl;
    if (!productUrl) return;

    if (!sourceButton.dataset.wmQuickAddOriginalHtml) {
      sourceButton.dataset.wmQuickAddOriginalHtml = sourceButton.innerHTML;
    }
    sourceButton.setAttribute('aria-busy', 'true');

    try {
      const jsonUrl = `${productUrl.split('?')[0]}.js`;
      const product = await fetch(jsonUrl, { headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      });
      const defaultVariant = product.variants.find((variant) => variant.available) || product.variants[0];
      const selectedOptions = productOptions(product).map((option, index) =>
        optionValueFromVariant(defaultVariant, index)
      );
      renderQuickAddModal(product, selectedOptions, sourceButton);
    } catch (error) {
      window.location.href = productUrl;
    } finally {
      sourceButton.removeAttribute('aria-busy');
    }
  }

  function initQuickAddModal() {
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.product-card-wrapper .wm-quick-add__submit[data-product-url]');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openQuickAdd(button);
      },
      true
    );
  }

  function storeCollectionReturn() {
    if (!/\/collections\//.test(window.location.pathname)) return;
    storageSet(collectionReturnKey, window.location.href);
  }

  function initCollectionContinuity() {
    storeCollectionReturn();

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-wm-collection-product-link], .grid__item a[href*="/products/"]');
      if (!link || !/\/collections\//.test(window.location.pathname)) return;
      storageSet(collectionReturnKey, window.location.href);
    });

    const returnUrl = storageGet(collectionReturnKey);
    if (!returnUrl) return;

    document.querySelectorAll('[data-wm-return-collection-link]').forEach((link) => {
      link.href = returnUrl;
      if (link.classList.contains('wm-back-link')) {
        link.textContent = 'Back to collection';
      }
    });

    document.querySelectorAll('[data-wm-preserve-collection-link]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('return_to', returnUrl);
        link.href = url.toString();
      } catch (error) {
        // Keep the original link if the browser cannot parse it.
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!appCompatibilityMode) initWishlist();
      initProductShare();
      initDiscountCopy();
      initQuickAddModal();
      if (!appCompatibilityMode) initCollectionContinuity();
    });
  } else {
    if (!appCompatibilityMode) initWishlist();
    initProductShare();
    initDiscountCopy();
    initQuickAddModal();
    if (!appCompatibilityMode) initCollectionContinuity();
  }
})();
